import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import Page from './Page';
import PageSection from './PageSection';
import Table from './Table';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class DashboardSales extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.actions = <a href="/sizing-form" className="pp-plus-button">Create Sizing Form</a>
		this.user = Auth.getProfile();
		this.state = {
			tableCreated: {
				tableHeading: [],
				tableBody: []
			},
            tableConfigured: {
				tableHeading: [],
				tableBody: []
			},
            tableApproved: {
				tableHeading: [],
				tableBody: []
			},
			tablePublished: {
				tableHeading: [],
				tableBody: []
			},
			createdResults: <p className="pp-loading">Loading sizing forms</p>,
			configuredResults: <p className="pp-loading">Loading sizing forms</p>,
			approvedResults: <p className="pp-loading">Loading sizing forms</p>,
			publishedResults: <p className="pp-loading">Loading published reports</p>
		};

		this.createdLink = <a href="/sizing-form/status/created" className="pp-text-button">View All</a>
		this.configuredLink = <a href="/sizing-form/status/configured" className="pp-text-button">View All</a>
		this.approvedLink = <a href="/sizing-form/status/approved" className="pp-text-button">View All</a>
		this.publishedLink = <a href="/sizing-form/status/published" className="pp-text-button">View All</a>

		this.Auth.fetch('/prediction/sizing-form?status=created')
			.then((result) => {
				let header = ['Boat', 'Date Created', 'Created By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						createdResults: "You have no sizing forms ready for configurations."
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						row.push(<a href={"/sizing-form/" + data.sizing_form_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						row.push(data.created_date);
						row.push(data.created_first_name + ' ' + data.created_last_name);
						rows.push(row);
					}

					this.setState({
						tableCreated: {
							tableHeading: header,
							tableBody: rows
						}
					});
				}
			});
        this.Auth.fetch('/prediction/sizing-form?status=configured')
			.then((result) => {
				let header = ['Boat', 'Date Configured', 'Configured By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						configuredResults: "You have no sizing forms pending approval."
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						row.push(<a href={"/sizing-form/" + data.sizing_form_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						row.push(data.configured_date);
						row.push(data.configured_first_name + ' ' + data.configured_last_name);
						rows.push(row);
					}

					this.setState({
						tableConfigured: {
							tableHeading: header,
							tableBody: rows
						}
					});
				}
			});
        this.Auth.fetch('/prediction/sizing-form?status=approved')
			.then((result) => {
				let header = ['Boat', 'Date Approved', 'Approved By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						approvedResults: "You have no sizing forms ready for publishing."
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						row.push(<a href={"/sizing-form/" + data.sizing_form_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						row.push(data.approved_date);
						row.push(data.approved_first_name + ' ' + data.approved_last_name);
						rows.push(row);
					}

					this.setState({
						tableApproved: {
							tableHeading: header,
							tableBody: rows
						}
					});
				}
			});
		this.Auth.fetch('/prediction/sizing-form?status=published&limit=50')
			.then((result) => {
				let header = ['Boat', 'Date Published', 'Published By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						publishedResults: "You have no pubished reports."
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						row.push(<a href={"/report/" + data.report_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						row.push(data.published_date);
						row.push(data.published_first_name + ' ' + data.published_last_name);
						rows.push(row);
					}

					this.setState({
						tablePublished: {
							tableHeading: header,
							tableBody: rows
						}
					});
				}
			});
	}

	render() {

		return (
			<Page pageTitle={this.user.pp_role_name + " Dashboard"} pageClass="pp-dashboard-page" pageActions={this.actions}>
				<div className="dashboard-content">
					<PageSection
						className="pp-status-created"
						sectionTitle="Ready for Configurations"
						sectionActions={this.createdLink}
					>
						<Table
							tableHeading={this.state.tableCreated.tableHeading}
							tableBody={this.state.tableCreated.tableBody}
							noResultsMessage={this.state.createdResults}
						/>
					</PageSection>

					<PageSection
						className="pp-status-configured"
						sectionTitle="Pending Approval"
						sectionActions={this.configuredLink}
					>
						<Table
							tableHeading={this.state.tableConfigured.tableHeading}
							tableBody={this.state.tableConfigured.tableBody}
							noResultsMessage={this.state.configuredResults}
						/>
					</PageSection>

					<PageSection
						className="pp-status-approved"
						sectionTitle="Ready for Publishing"
						sectionActions={this.approvedLink}
					>
						<Table
							tableHeading={this.state.tableApproved.tableHeading}
							tableBody={this.state.tableApproved.tableBody}
							noResultsMessage={this.state.approvedResults}
						/>
					</PageSection>

					<PageSection
						className="pp-status-published"
						sectionTitle="Published Reports"
						sectionActions={this.publishedLink}
					>
						<Table
							tableHeading={this.state.tablePublished.tableHeading}
							tableBody={this.state.tablePublished.tableBody}
							noResultsMessage={this.state.publishedResults}
						/>
					</PageSection>
				</div>
			</Page>
		);
	}
}

export default DashboardSales;



// WEBPACK FOOTER //
// ./src/components/DashboardSales.js